/* eslint-disable @typescript-eslint/no-explicit-any */
import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime'

const getSimpleHeaderConfig = ({
  copy,
  router,
}: {
  copy: any
  router: AppRouterInstance
}) => {
  return {
    goToStore: {
      text: copy?.goToStore,
      onClick: () => router.replace('/'),
    },
    goBack: {
      text: copy?.goBack,
      onClick: () => router.back(),
    },
    goBackStore: {
      text: copy?.goBackStore,
      onClick: () => router.replace('/'),
    },
    empty: {
      onClick: () => '',
      text: '',
    },
  }
}

export default getSimpleHeaderConfig
